// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMaxElectionAmountTypePropertyDto
 */
export interface IMaxElectionAmountTypePropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IMaxElectionAmountTypePropertyDto
     */
    max_election_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IMaxElectionAmountTypePropertyDto
     */
    max_election_amount_type?: IMaxElectionAmountTypePropertyDtoMaxElectionAmountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IMaxElectionAmountTypePropertyDto
     */
    irs_limit_type?: IMaxElectionAmountTypePropertyDtoIrsLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IMaxElectionAmountTypePropertyDto
     */
    max_election_amount_type_state?: IMaxElectionAmountTypePropertyDtoMaxElectionAmountTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMaxElectionAmountTypePropertyDtoMaxElectionAmountTypeEnum {
    UNLIMITED = 'UNLIMITED',
    IRS_LIMIT = 'IRS_LIMIT',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IMaxElectionAmountTypePropertyDtoIrsLimitTypeEnum {
    HCFSA_MAX = 'HCFSA_MAX',
    HSA_MAX = 'HSA_MAX',
    DCAP_MAX = 'DCAP_MAX',
    TRANSIT_MAX = 'TRANSIT_MAX',
    PARKING_MAX = 'PARKING_MAX',
    HCFSA_EE_ER_MAX = 'HCFSA_EE_ER_MAX'
}
/**
* @export
* @enum {string}
*/
export enum IMaxElectionAmountTypePropertyDtoMaxElectionAmountTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IMaxElectionAmountTypePropertyDto interface.
 */
export function instanceOfIMaxElectionAmountTypePropertyDto(value: object): value is IMaxElectionAmountTypePropertyDto {
    return true;
}

export function IMaxElectionAmountTypePropertyDtoFromJSON(json: any): IMaxElectionAmountTypePropertyDto {
    return IMaxElectionAmountTypePropertyDtoFromJSONTyped(json, false);
}

export function IMaxElectionAmountTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMaxElectionAmountTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'max_election_amount': json['max_election_amount'] == null ? undefined : json['max_election_amount'],
        'max_election_amount_type': json['max_election_amount_type'] == null ? undefined : json['max_election_amount_type'],
        'irs_limit_type': json['irs_limit_type'] == null ? undefined : json['irs_limit_type'],
        'max_election_amount_type_state': json['max_election_amount_type_state'] == null ? undefined : json['max_election_amount_type_state'],
    };
}

export function IMaxElectionAmountTypePropertyDtoToJSON(json: any): IMaxElectionAmountTypePropertyDto {
    return IMaxElectionAmountTypePropertyDtoToJSONTyped(json, false);
}

export function IMaxElectionAmountTypePropertyDtoToJSONTyped(value?: IMaxElectionAmountTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'max_election_amount': value['max_election_amount'],
        'max_election_amount_type': value['max_election_amount_type'],
        'irs_limit_type': value['irs_limit_type'],
        'max_election_amount_type_state': value['max_election_amount_type_state'],
    };
}

